export const USERS_COLUMNS_DIFINITION = [
    { id: 'displayName', type: "text", title: "Username/Email Address" },
    { id: 'createdAt', type: "date", title: "Last SignIn" },
    { id: 'phoneNumber', type: 'text', title: "Contact Number" },
    { id: 'userGroup', type: 'text', title: "User Group" },
    { id: 'emailVerified', type: 'bool', title: "Email Verified" },
    { id:'approvedByAdmin',type:'bool',title:"Approved By Admin"}
]